import { thunk } from "redux-thunk";
import { configureStore, Tuple } from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage";
import { persistReducer } from "redux-persist";
import { persistStore } from "redux-persist";

import rootReducer from "./rootReducer";

const persistConfig = {
  key: "root",
  version: 1,
  storage,
  // Never restore an in-flight request without the request that completes it.
  blacklist: ["acts", "allPages", "calls"],
  migrate: (state) => {
    if (!state) return Promise.resolve(state);

    const migratedState = { ...state };
    delete migratedState.allPages;
    delete migratedState.calls;
    return Promise.resolve(migratedState);
  },
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

// Create the store
const store = configureStore({
  reducer: persistedReducer,
  devTools: process.env.NODE_ENV !== "production",
  middleware: () => new Tuple(thunk),
});

const persistor = persistStore(store);

export { persistor };
export default store;
